import * as React from 'react';

import { PropertyAboutThisProperty } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface AboutThisPropertyProps extends SharedUiWrapperProps {
  columns?: number;
}

const AboutThisPropertyWrapper: React.FC<AboutThisPropertyProps> = ({ inputs, columns }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <PropertyAboutThisProperty inputs={inputs} columns={columns} />
  </UitkSpacing>
);

export const SharedUiAboutThisPropertyWrapper = withSharedUiPropertyDetails(AboutThisPropertyWrapper);
SharedUiAboutThisPropertyWrapper.displayName = 'SharedUiAboutThisPropertyWrapper';
